import { useTranslate } from 'hooks/useTranslate';
import { FC, ChangeEvent } from 'react';

type Props = {
  unPauseAllPlans: boolean;
  handleChangeUnPauseAllPlans: (event: ChangeEvent<HTMLInputElement>) => void;
};

const UnpauseBeneficiaryAllPlansSection: FC<Props> = ({
  unPauseAllPlans,
  handleChangeUnPauseAllPlans,
}) => {
  const { t } = useTranslate();

  return (
    <div className="form-group">
      <label className="form-label" htmlFor="default-01">
        {t('AllPlansPauseMessage1')}
      </label>

      <div className="row">
        <div className="col-md-6">
          <div className="form-group mt-2">
            <div className="custom-control custom-control-xs custom-checkbox">
              <input
                type="checkbox"
                id="checkbox-all-plans-unpause"
                className="custom-control-input"
                checked={unPauseAllPlans}
                onChange={handleChangeUnPauseAllPlans}
              />
              <label
                className="custom-control-label"
                htmlFor="checkbox-all-plans-unpause"
              >
                {t('AllPlansPauseMessage2')}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnpauseBeneficiaryAllPlansSection;

